"use strict";

var _toConsumableArray = require("/builds/wildnow/athlete-dashboard/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

var _classCallCheck = require("/builds/wildnow/athlete-dashboard/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/builds/wildnow/athlete-dashboard/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _assertThisInitialized = require("/builds/wildnow/athlete-dashboard/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/assertThisInitialized");

var _inherits = require("/builds/wildnow/athlete-dashboard/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/builds/wildnow/athlete-dashboard/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/builds/wildnow/athlete-dashboard/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _wrapNativeSuper = require("/builds/wildnow/athlete-dashboard/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapNativeSuper");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var _require = require("@jsdevtools/ono"),
    Ono = _require.Ono;

var _require2 = require("./url"),
    stripHash = _require2.stripHash,
    toFileSystemPath = _require2.toFileSystemPath;

var JSONParserError = exports.JSONParserError = /*#__PURE__*/function (_Error) {
  _inherits(JSONParserError, _Error);

  var _super = _createSuper(JSONParserError);

  function JSONParserError(message, source) {
    var _this;

    _classCallCheck(this, JSONParserError);

    _this = _super.call(this);
    _this.code = "EUNKNOWN";
    _this.message = message;
    _this.source = source;
    _this.path = null;
    Ono.extend(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(JSONParserError, [{
    key: "footprint",
    get: function get() {
      return "".concat(this.path, "+").concat(this.source, "+").concat(this.code, "+").concat(this.message);
    }
  }]);

  return JSONParserError;
}( /*#__PURE__*/_wrapNativeSuper(Error));

setErrorName(JSONParserError);

var JSONParserErrorGroup = exports.JSONParserErrorGroup = /*#__PURE__*/function (_Error2) {
  _inherits(JSONParserErrorGroup, _Error2);

  var _super2 = _createSuper(JSONParserErrorGroup);

  function JSONParserErrorGroup(parser) {
    var _this2;

    _classCallCheck(this, JSONParserErrorGroup);

    _this2 = _super2.call(this);
    _this2.files = parser;
    _this2.message = "".concat(_this2.errors.length, " error").concat(_this2.errors.length > 1 ? "s" : "", " occurred while reading '").concat(toFileSystemPath(parser.$refs._root$Ref.path), "'");
    Ono.extend(_assertThisInitialized(_this2));
    return _this2;
  }

  _createClass(JSONParserErrorGroup, [{
    key: "errors",
    get: function get() {
      return JSONParserErrorGroup.getParserErrors(this.files);
    }
  }], [{
    key: "getParserErrors",
    value: function getParserErrors(parser) {
      var errors = [];

      for (var _i = 0, _Object$values = Object.values(parser.$refs._$refs); _i < _Object$values.length; _i++) {
        var $ref = _Object$values[_i];

        if ($ref.errors) {
          errors.push.apply(errors, _toConsumableArray($ref.errors));
        }
      }

      return errors;
    }
  }]);

  return JSONParserErrorGroup;
}( /*#__PURE__*/_wrapNativeSuper(Error));

setErrorName(JSONParserErrorGroup);

var ParserError = exports.ParserError = /*#__PURE__*/function (_JSONParserError) {
  _inherits(ParserError, _JSONParserError);

  var _super3 = _createSuper(ParserError);

  function ParserError(message, source) {
    var _this3;

    _classCallCheck(this, ParserError);

    _this3 = _super3.call(this, "Error parsing ".concat(source, ": ").concat(message), source);
    _this3.code = "EPARSER";
    return _this3;
  }

  return _createClass(ParserError);
}(JSONParserError);

setErrorName(ParserError);

var UnmatchedParserError = exports.UnmatchedParserError = /*#__PURE__*/function (_JSONParserError2) {
  _inherits(UnmatchedParserError, _JSONParserError2);

  var _super4 = _createSuper(UnmatchedParserError);

  function UnmatchedParserError(source) {
    var _this4;

    _classCallCheck(this, UnmatchedParserError);

    _this4 = _super4.call(this, "Could not find parser for \"".concat(source, "\""), source);
    _this4.code = "EUNMATCHEDPARSER";
    return _this4;
  }

  return _createClass(UnmatchedParserError);
}(JSONParserError);

setErrorName(UnmatchedParserError);

var ResolverError = exports.ResolverError = /*#__PURE__*/function (_JSONParserError3) {
  _inherits(ResolverError, _JSONParserError3);

  var _super5 = _createSuper(ResolverError);

  function ResolverError(ex, source) {
    var _this5;

    _classCallCheck(this, ResolverError);

    _this5 = _super5.call(this, ex.message || "Error reading file \"".concat(source, "\""), source);
    _this5.code = "ERESOLVER";

    if ("code" in ex) {
      _this5.ioErrorCode = String(ex.code);
    }

    return _this5;
  }

  return _createClass(ResolverError);
}(JSONParserError);

setErrorName(ResolverError);

var UnmatchedResolverError = exports.UnmatchedResolverError = /*#__PURE__*/function (_JSONParserError4) {
  _inherits(UnmatchedResolverError, _JSONParserError4);

  var _super6 = _createSuper(UnmatchedResolverError);

  function UnmatchedResolverError(source) {
    var _this6;

    _classCallCheck(this, UnmatchedResolverError);

    _this6 = _super6.call(this, "Could not find resolver for \"".concat(source, "\""), source);
    _this6.code = "EUNMATCHEDRESOLVER";
    return _this6;
  }

  return _createClass(UnmatchedResolverError);
}(JSONParserError);

setErrorName(UnmatchedResolverError);

var MissingPointerError = exports.MissingPointerError = /*#__PURE__*/function (_JSONParserError5) {
  _inherits(MissingPointerError, _JSONParserError5);

  var _super7 = _createSuper(MissingPointerError);

  function MissingPointerError(token, path) {
    var _this7;

    _classCallCheck(this, MissingPointerError);

    _this7 = _super7.call(this, "Token \"".concat(token, "\" does not exist."), stripHash(path));
    _this7.code = "EMISSINGPOINTER";
    return _this7;
  }

  return _createClass(MissingPointerError);
}(JSONParserError);

setErrorName(MissingPointerError);

var InvalidPointerError = exports.InvalidPointerError = /*#__PURE__*/function (_JSONParserError6) {
  _inherits(InvalidPointerError, _JSONParserError6);

  var _super8 = _createSuper(InvalidPointerError);

  function InvalidPointerError(pointer, path) {
    var _this8;

    _classCallCheck(this, InvalidPointerError);

    _this8 = _super8.call(this, "Invalid $ref pointer \"".concat(pointer, "\". Pointers must begin with \"#/\""), stripHash(path));
    _this8.code = "EINVALIDPOINTER";
    return _this8;
  }

  return _createClass(InvalidPointerError);
}(JSONParserError);

setErrorName(InvalidPointerError);

function setErrorName(err) {
  Object.defineProperty(err.prototype, "name", {
    value: err.name,
    enumerable: true
  });
}

exports.isHandledError = function (err) {
  return err instanceof JSONParserError || err instanceof JSONParserErrorGroup;
};

exports.normalizeError = function (err) {
  if (err.path === null) {
    err.path = [];
  }

  return err;
};